import { useEffect } from 'react';
import { MobileMenuPanel } from '../routes/mobile/MenuPage.js';
import './mobileMenuDrawer.css';

/**
 * The phone/tablet menu, opened from the bottom bar's «منو» as a drawer over
 * the current page (the page behind stays where it was) instead of routing to
 * a separate screen. It wears the sidebar's own theme colours and covers
 * about 80% of the screen; the backdrop, Escape, the close button and
 * following any link all close it.
 *
 * UI_REFERENCE_SOURCE: Sakhtar Mobile App.dc.html §FRAME 08 مینو — mobile
 *   menu drawer (overlay + panel); rows are the same V2Drawer rows the
 *   routed page already uses.
 */
export function MobileMenuDrawer({
  slug,
  open,
  onClose,
}: {
  readonly slug: string;
  readonly open: boolean;
  readonly onClose: () => void;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previous;
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="sk-mobile-drawer-root" dir="rtl">
      <div className="sk-mobile-drawer-backdrop" aria-hidden="true" onClick={onClose} />
      <aside className="sk-mobile-drawer" role="dialog" aria-modal="true" aria-label="منوی اصلی">
        <MobileMenuPanel slug={slug} onNavigate={onClose} onClose={onClose} />
      </aside>
    </div>
  );
}
